/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, disable, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED CONTROL BAR : STYLES --------------- ++++++++++ */
export default theme => ({
	controlbar: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',

		// ----- searchbar ----- //
		'& .searchbar': {
			maxWidth: pxToEm(815),
			minWidth: pxToEm(200),
			marginRight: pxToEm(20),
			width: '100%'
		},
		'& .searchlabel': {
			display: 'flex',
			alignItems: 'center',
			marginBottom: pxToEm(32),
			'& .label': {
				color: 'rgba(6, 43, 117, 0.4)',
				fontWeight: '500'
			}
		},
		// ----- filters ----- //
		'& .name-filters': {
			marginBottom: pxToEm(30),
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			flexWrap: 'wrap',
			'& .dropdown': {
				marginRight: pxToEm(10)
			},
			'& .text': {
				marginRight: pxToEm(15),
				minWidth: 'fit-content'
			},
			'& .active': {
				marginRight: pxToEm(32),
				marginBottom: pxToEm(10),
				marginTop: pxToEm(10),
				display: 'flex'
			}
		},
		'& .sortby':{
			display: 'flex',
			alignItems: 'center',
			// '& .dropdown': {
			// 	zIndex: '14'
			'& .contentsort': {
				position: 'relative',
				zIndex: '14'
			},
			'& .dropDownItem': {
				padding: pxToEm(7)
			}
		},
		'& .showing':{
			display: 'flex',
			alignItems: 'center',
			'& .dropdown': {
				'&:nth-child(1)': {zIndex: '13'},
				'&:nth-child(2)': {zIndex: '12', justifySelf: 'flex-end'},
				'&:nth-child(3)': {zIndex: '11', justifySelf: 'flex-end'}
			}
		},
		'&.disabled-true':{
			extend: disable
		}
	},
	[mediaQuery.medium]:{
		controlbar:{
			'& .name-filters': {
				alignItems: 'flex-start',
				flexDirection: 'column',
				'& .sortby':{
					marginBottom: pxToEm(15)
				},
				'& .showing':{
					display: 'flex',
					flexWrap: 'wrap',
					'& .searchabledropdown':{
						width: pxToEm(240)
					}
				},
				'& .active': {
					marginBottom: pxToEm(10)
				}
			}
		}
	},
	[mediaQuery.thinnest]: {
		controlbar: {
			flexDirection: 'column',
			'& .searchbar': {
				maxWidth: '100% !important',
				width: '100%',
				marginBottom: pxToEm(15)
			},
			'& .name-filters': {
				justifyContent: 'flex-start',
				'& .sortby':{
					marginBottom: pxToEm(15)
				},
				'& .showing, .sortby, .datepickerdropdown, .searchabledropdown':{
					minWidth: '100%',
					maxWidth: '100%',
					flexDirection: 'column',
					alignItems: 'baseline',
					'& .searchabledropdown':{
						maxWidth: '100%',
						width: '100%',
						height: 'auto',
						marginRight: '0',
						marginBottom: pxToEm(10)
					}
				},
				'& .active': {

				},
				'& .text': {
					marginBottom: pxToEm(15)
				}
			},
			'& .active': {
				marginBottom: pxToEm(10),
				width: '100%',
				'& .control': {
					width: '50%'
				}
			}
		}
	}
});
